/* eslint-disable no-return-await,no-underscore-dangle */
import { ChatMessageType, KurentoRequest } from '_helpers';
import { HubConnection } from '@microsoft/signalr';

export class OnlineMethods {
    private _connection: HubConnection;

    constructor(connection: HubConnection) {
        this._connection = connection;
    }

    public init = async () => await this._connection.send('init');

    public getChatMessages = async (applicantId: string) => await this._connection.send('getChatMessages', applicantId);

    public markAsRead = async (applicantId: string) => await this._connection.send('markAsRead', applicantId);

    public sendChatMessageToApplicantExam = async (
      type: ChatMessageType,
      applicantId: string,
      message: string,
    ) => await this._connection.send(
      'sendChatMessageToApplicantExam',
      type,
      applicantId,
      message,
    );

    public sendKurentoMessage = async (message: KurentoRequest) => await this._connection.send(
      'sendKurentoMessage',
      message,
    );
}


// init()
// getChatMessages(string applicantId)
// sendChatMessageToApplicantExam(ChatMessageType type, string applicantId, string message)
// sendKurentoMessage(KurentoRequest message)

// connection.send('sendChatMessageToApplicantExam', 'message', 'aaa00000-0000-0000-0000-000000000001', 'hello' );


// ---------------- for exam:
// init()
// getChatMessages()
// sendChatMessageToExpert(ChatMessageType type, string message)
// sendKurentoMessage(KurentoRequest message)
